$(document).ready(function() {
  $('.js-employer-user-select').on('change', function () {
    if ($(this).val()) {
      window.location.href = '/personal/exams/?user_id=' + $(this).val();
    }
  });
});
